import { z } from 'zod';
import CustomerUserAuthorizationRole from '../enums/CustomerUserAuthorizationRoles';
import { BaseSchema } from './BaseSchema';
import { CustomerSchema } from './Customer/Customer';
export var CustomerUserAuthorizationSchema = BaseSchema.extend({
    customer: z.union([z.string(), CustomerSchema]),
    role: z.nativeEnum(CustomerUserAuthorizationRole),
    inviteToken: z.string().optional(),
    user: z.union([z.string(), z.any()]),
    parentUser: z.union([z.string(), z.any()])
});
